import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RefreshButtonProps {
  onClick?: () => void;
  label?: string;
  isRefreshing?: boolean;
  className?: string;
  variant?: 'ghost' | 'outline' | 'default';
  size?: 'sm' | 'default' | 'lg' | 'icon';
}

export const RefreshButton: React.FC<RefreshButtonProps> = ({
  onClick = () => window.location.reload(),
  label = 'Refresh',
  isRefreshing = false,
  className,
  variant = 'ghost',
  size = 'sm',
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={isRefreshing}
      className={cn(
        'flex items-center gap-1.5 text-black hover:text-foreground border border-gray-300 rounded-full',
        className
      )}
    >
      <RefreshCw className={cn('h-4 w-4', isRefreshing && 'animate-spin')} />
      {label}
    </Button>
  );
};
